import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Seo from "@/components/common/Seo";

export default function NotFound() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-4 text-center">
      <Seo title="Page Not Found" />
      <p className="font-display text-[100px] font-extrabold leading-none tracking-[-0.04em] text-white/10">404</p>
      <h1 className="mt-4 font-display text-3xl font-bold">Page not found</h1>
      <p className="mt-3 max-w-md text-[15px] text-white/55">The page you're looking for doesn't exist or has moved.</p>
      <Link to="/" className="mt-7 inline-flex items-center gap-2 rounded-[12px] bg-white px-6 py-3.5 text-[15px] font-semibold text-black transition-colors hover:bg-white/90">
        <ArrowLeft size={16} /> Back to Home
      </Link>
    </div>
  );
}
